import headerStore from './src/store';

function install(Vue, options = {}) {
	const {store} = options;

	// Register the store
	store.registerModule(
		'header',
		Object.assign({namespaced: true}, headerStore)
	);

}

export default install;
